import React from "react";
import { Receipt } from "lucide-react";
import { fmtDate } from "./ProfileStatusCard";

const KIND_LABEL = { trial: "Free trial started", invoice: "Subscription payment", checkout: "Purchase" };

export function BillingHistory({ purchases, labels }) {
  return (
    <div className="mt-4">
      <div className="label-caps text-parchment/60 flex items-center gap-2 mb-2"><Receipt className="w-3 h-3" strokeWidth={1.5} /> Billing history</div>
      <div className="rounded-lg border border-white/10 overflow-hidden" data-testid="profile-purchases">
        {purchases.length === 0 && <div className="px-4 py-6 text-center font-body text-xs text-parchment/40" data-testid="profile-no-purchases">No payments yet.</div>}
        {purchases.map((p) => (
          <div key={p.receipt + p.date} data-testid="profile-purchase-row" className="flex flex-wrap sm:grid sm:grid-cols-12 gap-x-3 gap-y-0.5 px-4 py-2.5 border-b border-white/5 last:border-0 font-body text-xs items-center">
            <div className="sm:col-span-4 text-parchment/70 w-full sm:w-auto">{fmtDate(p.date)}</div>
            <div className="sm:col-span-5 text-parchment flex-1 min-w-0">{labels[p.plan] || p.plan}<span className="text-parchment/40"> · {KIND_LABEL[p.kind] || p.kind}{p.provider === "paypal" ? " · PayPal" : ""} · #{p.receipt}</span></div>
            <div className="sm:col-span-3 sm:text-right text-oracle">{p.kind === "trial" ? "$0.00" : `$${Number(p.amount).toFixed(2)}`}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function PassTimeline({ passes, labels }) {
  if (passes.length === 0) return null;
  return (
    <div className="mt-4">
      <div className="label-caps text-parchment/60 mb-2">Pass & bonus days</div>
      <ul className="space-y-1 font-body text-xs">
        {passes.map((p) => (
          <li key={p.id || `${p.starts_at}-${p.expires_at}`} className="flex justify-between text-parchment/60">
            <span>{labels[p.plan] || "Pass"} · {p.days}d</span>
            <span>{fmtDate(p.starts_at)} → {fmtDate(p.expires_at)}{p.active ? <span className="text-oracle"> · active</span> : ""}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
